import { authSectionTypes } from '../modules/authorization/authorization.type';

export const AuthForm: authSectionTypes = {
  login: {
    1: {
      step: 1,
      title: 'Sign in',
      subtitle: {
        text: 'Please enter your email address and password to access your account.',
        navigation: {
          text: 'SignUp',
          url: 'registration',
        },
      },
      button: {
        func: 'logIn',
        type: 1,
        text: 'Log In',
        disabled: true,
      },
      inputs: [
        {
          type: 'email',
          typeOfInput: 'input',
          label: 'Email',
          name: 'email',
          placeholder: 'Enter your email',
          validation: {
            type: 'text',
            status: null,
          },
          disabled: false,
          id: 1,
          tabIndex: 1
        },
        {
          type: 'password',
          label: 'Password',
          typeOfInput: 'input',
          name: 'password',
          placeholder: 'Enter your password',
          validation: {
            type: 'text',
            status: null,
          },
          disabled: false,
          id: 2,
          tabIndex: 2
        },
      ],
      loginWith: [],
      error: {
        status: false,
        message: '',
      },
      rememberMeBlock: true,
      termsandPrivecy: false,
      backButton: {
        status: false,
        step: 0,
      },
    },
    2: {
      step: 2,
      title: 'Verify Email',
      subtitle: {
        text: 'We sent a code to',
        navigation: {
          text: '',
          url: '',
        },
      },
      button: {
        func: 'verifyEmail',
        type: 1,
        text: 'Confirm',
        disabled: true,
      },
      inputs: [
        {
          type: 'number',
          label: 'Code',
          typeOfInput: 'input',
          name: 'code',
          placeholder: 'Enter',
          validation: {
            type: 'text',
            status: null,
          },
          disabled: false,
          id: 9,
        },
      ],
      error: {
        status: false,
        message: '',
      },
      resend: {
        status: true,
        func: 'resendVerifyCode',
      },
      backButton: {
        status: true,
        step: 1,
      },
    },
  },
  registration: {
    1: {
      step: 1,
      title: 'Register',
      subtitle: {
        text: 'Already have an account?',
        navigation: {
          text: 'LogIn',
          url: 'login',
        },
      },
      button: {
        func: 'registration',
        type: 1,
        text: 'Continue',
        disabled: true,
      },
      inputs: [
        {
          type: 'email',
          typeOfInput: 'input',
          label: 'Email',
          name: 'email',
          placeholder: 'Enter your email',
          validation: {
            type: 'email',
            status: null,
            error: 'incorrect email, please try again',
          },
          value: '',
          disabled: false,
          id: 3,
          tabIndex: 1
        },
        {
          type: 'text',
          label: 'Username',
          typeOfInput: 'input',
          name: 'username',
          placeholder: 'Enter your username',
          validation: {
            type: 'text',
            status: null,
          },
          value: '',
          disabled: false,
          id: 4,
          tabIndex: 2
        },
        {
          type: 'select',
          typeOfInput: 'select',
          label: 'Gender',
          name: 'gender',
          placeholder: 'Select your gender',
          validation: {
            type: 'select',
            status: null,
          },
          value: '',
          options: [
            {
              value: '1',
              id: 1,
              text: 'Male',
            },
            {
              value: '2',
              id: 2,
              text: 'Female',
            },
          ],
          disabled: false,
          id: 5,
          tabIndex: 3
        },
        {
          type: 'date',
          label: 'Date of birth',
          typeOfInput: 'date',
          name: 'date',
          placeholder: 'Enter your Date',
          validation: {
            type: 'date',
            status: null,
            error: 'Date of birth cannot be less than 4 years',
          },
          value: '',
          disabled: false,
          id: 6,
          tabIndex: 4
        },
        {
          type: 'new-password',
          label: 'Create Password',
          name: 'password',
          typeOfInput: 'input',
          placeholder: 'Create password',
          validation: {
            type: 'password',
            status: null,
          },
          value: '',
          disabled: false,
          id: 7,
          tabIndex: 5
        },
        {
          type: 'confirm-password',
          label: 'Confirm Password',
          typeOfInput: 'input',
          name: 'confpassword',
          placeholder: 'Confirm password',
          validation: {
            type: 'confirmPass',
            status: null,
            error: 'Make sure both passwords are identical',
          },
          value: '',
          disabled: false,
          id: 8,
          tabIndex: 6
        },
      ],
      error: {
        status: false,
        message: '',
      },
      termsandPrivecy: true,
      backButton: {
        status: false,
        step: 0,
      },
    },
    2: {
      step: 2,
      title: 'Verify Email',
      subtitle: {
        text: 'We sent a code to',
        navigation: {
          text: '',
          url: '',
        },
      },
      button: {
        func: 'verifyEmail',
        type: 1,
        text: 'Confirm',
        disabled: true,
      },
      inputs: [
        {
          type: 'number',
          label: 'Code',
          typeOfInput: 'input',
          name: 'code',
          placeholder: 'Enter',
          validation: {
            type: 'text',
            status: null,
          },
          disabled: false,
          id: 9,
          tabIndex: 1
        },
      ],
      error: {
        status: false,
        message: '',
      },
      resend: {
        status: true,
        func: 'resendVerifyCode',
      },
      backButton: {
        status: true,
        step: 1,
      },
    },
  },
  forgot: {
    1: {
      step: 1,
      title: 'Password Recovery',
      subtitle: {
        text: 'Please, enter your email. We will sent a verification email.',
      },
      button: {
        func: 'checkForgotEmail',
        type: 1,
        text: 'Continue',
        disabled: true,
      },
      inputs: [
        {
          type: 'email',
          typeOfInput: 'input',
          label: 'Email',
          name: 'email',
          placeholder: 'Enter your email',
          validation: {
            type: 'email',
            status: null,
            error: 'Incorrect email, please try again',
          },
          disabled: false,
          id: 109,
          tabIndex: 1
        },
      ],
      error: {
        status: false,
        message: '',
      },
      rememberMeBlock: false,
      backButton: {
        status: true,
        step: 0,
      },
    },
    2: {
      step: 2,
      title: 'Password Recovery',
      subtitle: {
        text: 'We sent a code to',
        navigation: {
          text: '',
          url: '',
        },
      },
      button: {
        func: 'checkForgotCode',
        type: 1,
        text: 'Continue',
        disabled: true,
      },
      inputs: [
        {
          type: 'text',
          label: 'Code',
          typeOfInput: 'input',
          name: 'code',
          placeholder: 'Enter',
          validation: {
            type: 'number',
            status: null,
          },
          disabled: false,
          id: 9,
          tabIndex: 1
        },
      ],
      error: {
        status: false,
        message: '',
      },
      rememberMeBlock: false,
      resend: {
        status: true,
        func: 'resendForgotCode',
      },
      backButton: {
        status: true,
        step: 1,
      },
    },
    3: {
      step: 3,
      title: 'Password Recovery',
      button: {
        func: 'createNewPass',
        type: 1,
        text: 'Confirm',
        disabled: true,
      },
      inputs: [
        {
          type: 'password',
          label: 'Create Password',
          name: 'password',
          typeOfInput: 'input',
          placeholder: 'Create password',
          validation: {
            type: 'password',
            status: null,
          },
          disabled: false,
          id: 7,
          tabIndex: 1
        },
        {
          type: 'password',
          label: 'Confirm Password',
          typeOfInput: 'input',
          name: 'confpassword',
          placeholder: 'Confirm password',
          validation: {
            type: 'confirmPass',
            status: null,
            error: 'Make sure both passwords are identical',
          },
          disabled: false,
          id: 8,
          tabIndex: 2
        },
      ],
      error: {
        status: false,
        message: '',
      },
      rememberMeBlock: false,
      backButton: {
        status: true,
        step: 2,
      },
    },
  },
};

export const authErrors:any = {
  username: "The Username should be unique."
}
